/**
 * OrderConfirmedContainer
 * --
 */
import React from 'react';
import OrderConfirmedPresenter from './OrderConfirmedPresenter';

const OrderConfirmedContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <OrderConfirmedPresenter />
    </>
  );
};

export default OrderConfirmedContainer;
